import { Building2, History, LayoutDashboard, TriangleAlert, UserCog, UserRound, type LucideIcon } from 'lucide-react';
import type { OperatorPermission } from '../auth/useOperatorMe';

export interface ConsoleNavEntry {
  readonly key: 'overview' | 'tenants' | 'problems' | 'audit' | 'operators' | 'account';
  readonly path: string;
  readonly icon: LucideIcon;
  readonly end?: boolean;
  /** Shown only with this permission; the server checks it again (REQ-140-003). */
  readonly permission?: OperatorPermission;
}

/** The console's navigation (spec 140 §4.5). */
export const CONSOLE_NAV: readonly ConsoleNavEntry[] = [
  { key: 'overview', path: '/', icon: LayoutDashboard, end: true },
  { key: 'tenants', path: '/tenants', icon: Building2 },
  { key: 'problems', path: '/problems', icon: TriangleAlert },
  { key: 'audit', path: '/audit', icon: History },
  { key: 'operators', path: '/operators', icon: UserCog, permission: 'operators:manage' },
  { key: 'account', path: '/account', icon: UserRound },
];
